module.exports = __webpack_public_path__ + "img/pic6.8ee9aabc.png";